import set from 'lodash/set';
import has from 'lodash/has';
import cloneDeep from 'lodash/cloneDeep';

export const setRequestProperty = (request, property, value) => {
  const clonedRequest = cloneDeep(request);

  if (request.method === 'get') {
    return set(clonedRequest, `properties.${property}`, value);
  }

  const queryPath = has(request, 'body.customerSearchRequest.queryParams')
    ? 'body.customerSearchRequest.queryParams'
    : 'body.queryParams';

  return set(clonedRequest, `${queryPath}.${property}`, value);
};
